import React, { Component } from "react";
import { Tooltip } from "@revvsales/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  FONT_FAMILY_OPTIONS,
  FONT_WEIGHT_OPTIONS,
} from "../../../constants/document";
import { ASSET } from "../../../constants";
import FontWeightDropdown from "./FontWeightDropdown";
import { checkStylesInSelection } from "../../../utils/editorUtils";
import { getClosestFontWeightStyle } from "../../../utils/draftUtils";

const { FONT_STYLES_WITH_OPTIONS } = ASSET;

export default class CustomFontStyle extends Component {
  listRef = {};

  constructor(props) {
    super(props);
    this.state = {
      fontFamilyTitle: "Arial",
      fontWeight: null,
      hoveredID: "",
      style: {},
    };
  }

  componentWillMount = () => {
    document.addEventListener("mousedown", this._handleClick, false);
  };

  componentDidMount = () => {
    this._setCurrentSelectedStyle();
    if (this.props.activeToolbarDropDown) {
      this.props.toogleToolbarDropDown(null);
    }
  };

  componentDidUpdate = prevProps => {
    if (
      prevProps.editorState.getSelection().getFocusOffset() !==
        this.props.editorState.getSelection().getFocusOffset() &&
      !this.props.editorState.getSelection().isCollapsed()
    ) {
      const { editorState } = this.props;
      const checkCount = checkStylesInSelection(editorState, "FONTFAMILY");
      if (checkCount > 1) {
        this.setState({
          fontFamilyTitle: null,
        });
        return;
      }
    }
    if (
      prevProps.editorState.getSelection().getAnchorOffset() !==
        this.props.editorState.getSelection().getAnchorOffset() ||
      (prevProps.editorState.getSelection().getFocusOffset() !==
        prevProps.editorState.getSelection().getAnchorOffset() &&
        this.props.editorState.getSelection().getFocusOffset() ===
          this.props.editorState.getSelection().getAnchorOffset())
    ) {
      const { editorState } = this.props;
      const checkCount = checkStylesInSelection(editorState, "FONTFAMILY");
      if (checkCount > 1) {
        this.setState({
          fontFamilyTitle: null,
          fontWeight: null,
        });
        return;
      }
      this._setCurrentSelectedStyle();
    }
  };

  componentWillUnmount = () => {
    this.setState({
      hoveredID: "",
      style: {},
    });
    document.removeEventListener("mousedown", this._handleClick, false);
  };

  _handleClick = e => {
    if (
      !this.node.contains(e.target) &&
      this.props.activeToolbarDropDown === "FONT_STYLE"
    ) {
      this.props.toogleToolbarDropDown(null);
    }
  };

  _saveMetaData = (fontStyle, fontWeight) => {
    const data = [
      {
        op: "replace",
        field: "meta_data",
        value: {
          meta_data: {
            ...this.props.metaData,
            FONTFAMILY: fontStyle,
            FONTWEIGHT: fontWeight,
          },
        },
      },
    ];

    this.props.saveMetaData(data);
  };

  _onChange = (fontStyle, fontValue, fontWeightStyle, fontWeight) => {
    if (!fontWeight || !fontWeightStyle) {
      const { newFontWeightStyle, newFontWeight } = this._getClosestFontWeight(
        fontStyle,
        fontValue,
      );
      fontWeightStyle = newFontWeightStyle;
      fontWeight = newFontWeight;
    }

    const { fontFamilyUpdate } = this.props;
    this._saveMetaData(fontStyle, fontWeightStyle);
    fontFamilyUpdate(fontStyle, fontValue, fontWeightStyle);
    this.setState({
      fontFamilyTitle: fontValue,
      fontWeight,
    });
    this.props.toogleToolbarDropDown(null);
  };

  _toggleDropdown = event => {
    event.preventDefault();
    this.props.toogleToolbarDropDown(
      this.props.activeToolbarDropDown === "FONT_STYLE" ? null : "FONT_STYLE",
    );
  };

  _setListDropdownStyles = e => {
    if (this.listRef && this.listRef[e.target.id]) {
      const ele = this.listRef[e.target.id];
      const rect = ele.getBoundingClientRect();
      if (this.state.hoveredID !== e.target.id) {
        let calcoTop = rect.top - 163;
        if (rect.top < 200) {
          calcoTop = rect.top - 130;
        }
        if (rect.top > 450) {
          calcoTop = rect.top - 196;
        }
        if (rect.top > 500 && rect.top < 550) {
          calcoTop = rect.top - 196;
        }
        if (rect.top > 570) {
          calcoTop = rect.top - 229;
        }
        this.setState({
          hoveredID: e.target.id,
          style: {
            top: calcoTop,
            left: rect.left - 10,
          },
        });
      }
    }
  };

  _getFontStyleFamily = (e, fontFamily) => {
    e.preventDefault();
    const { textContent } = e.target;
    if (
      !(
        textContent === "Light" ||
        textContent === "Regular" ||
        textContent === "Medium" ||
        textContent === "Semibold" ||
        textContent === "Bold" ||
        textContent === "Extrabold"
      )
    ) {
      this._onChange(e.currentTarget.id, fontFamily, null, null);
    }
  };

  _getFontStyleWeight = (fontStyle, fontValue, fontWeight) => {
    let fontWeightStyle;
    switch (fontWeight) {
      case "Light":
        fontWeightStyle = "FONTWEIGHT_LIGHT";
        break;
      case "Regular":
        fontWeightStyle = "FONTWEIGHT_REGULAR";
        break;
      case "Medium":
        fontWeightStyle = "FONTWEIGHT_MEDIUM";
        break;
      case "Semibold":
        fontWeightStyle = "FONTWEIGHT_SEMIBOLD";
        break;
      case "Bold":
        fontWeightStyle = "FONTWEIGHT_BOLD";
        break;
      case "Extrabold":
        fontWeightStyle = "FONTWEIGHT_EXTRABOLD";
        break;
      default:
        fontWeightStyle = "";
    }
    this._onChange(fontStyle, fontValue, fontWeightStyle, fontWeight);
  };

  _getClosestFontWeight(fontStyle, fontValue) {
    const { editorState } = this.props;
    let fontWeightStyle = null;
    let fontWeight = null;
    // if no font weight, get current font weight & find closed one
    const currentInlineStyles = editorState.getCurrentInlineStyle();
    if (currentInlineStyles && currentInlineStyles.size > 0) {
      const oldFontWeight = currentInlineStyles.filter(style =>
        style.startsWith("FONTWEIGHT"),
      );
      if (oldFontWeight && oldFontWeight.size > 0) {
        const { newFontWeightStyle, newFontWeight } = getClosestFontWeightStyle(
          [...oldFontWeight][0],
          fontStyle,
          fontValue,
        );
        fontWeightStyle = newFontWeightStyle;
        fontWeight = newFontWeight;
      }
    }
    return { newFontWeightStyle: fontWeightStyle, newFontWeight: fontWeight };
  }

  _setCurrentSelectedStyle() {
    const { editorState } = this.props;
    const editorTextValue = editorState
      .getCurrentContent()
      .getPlainText("\u0001");
    const state = { fontFamilyTitle: null, fontWeight: null };
    Object.entries(FONT_FAMILY_OPTIONS).forEach(([key, value]) => {
      if (editorState.getCurrentInlineStyle().has(key)) {
        state.fontFamilyTitle = value.fontFamily;
      }
    });

    Object.entries(FONT_WEIGHT_OPTIONS).forEach(([key, value]) => {
      if (editorState.getCurrentInlineStyle().has(key)) {
        state.fontWeight = value.fontWeightName;
      }
    });

    if (state.fontFamilyTitle === null && editorTextValue === "") {
      if (this.props.metaData && this.props.metaData.FONTFAMILY) {
        state.fontFamilyTitle =
          FONT_FAMILY_OPTIONS[this.props.metaData.FONTFAMILY].fontFamily;
        if (
          this.props.metaData.FONTWEIGHT &&
          this.props.metaData.FONTWEIGHT.startsWith("FONTWEIGHT")
        ) {
          state.fontWeight =
            FONT_WEIGHT_OPTIONS[this.props.metaData.FONTWEIGHT].fontWeightName;
        }
      } else state.fontFamilyTitle = "Open Sans";
    }

    if (state.fontFamilyTitle === null) state.fontFamilyTitle = "Arial";
    this.setState(state);
  }

  render() {
    const { activeToolbarDropDown } = this.props;
    return (
      <div
        className="draft-edit-items custom-font-style"
        ref={ele => {
          this.node = ele;
        }}>
        <Tooltip
          placement="top"
          overlay="Font"
          align={{
            offset: [3, 0],
          }}>
          <button
            data-test="custom-font-style-btn"
            className={`toolbar-custom-inline-button toolbar-btn option-font-type ${
              activeToolbarDropDown === "FONT_STYLE" ? "active" : ""
            }`}
            type="button"
            onMouseDown={this._toggleDropdown}>
            <span className="font-title">{this.state.fontFamilyTitle}</span>
            <i className="ic-dropdown">
              <FontAwesomeIcon
                icon={["far", "angle-down"]}
                className="breadcrumb-bredcrumb-icon"
              />
            </i>
          </button>
        </Tooltip>
        {activeToolbarDropDown === "FONT_STYLE" && (
          <div className="custom-font-style-wrapper">
            <div className="custom-font-style-container">
              <ul className="custom-font-style-options show-scrollbar">
                {Object.entries(FONT_FAMILY_OPTIONS).map(([key, value]) => {
                  const optionsAvailable = FONT_STYLES_WITH_OPTIONS.includes(
                    value.fontFamily,
                  );
                  const isActive =
                    value.fontFamily === this.state.fontFamilyTitle;
                  return (
                    <li // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                      role="button"
                      ref={ele => {
                        this.listRef[key] = ele;
                      }}
                      className={`custom-font-style-list-item ${
                        isActive ? "active" : ""
                      } ${optionsAvailable ? " list-with-dropdown  " : " "}`}
                      id={key}
                      tabIndex={0}
                      onMouseDown={e => {
                        this._getFontStyleFamily(e, value.fontFamily);
                      }}
                      onMouseOver={
                        optionsAvailable ? this._setListDropdownStyles : null
                      }
                      onFocus={() => {}}
                      value={value.fontFamily}
                      // eslint-disable-next-line prettier/prettier
                    style={{ fontFamily: value.fontFamily, }}>
                      {optionsAvailable ? (
                        <FontWeightDropdown
                          fontStyle={key}
                          style={this.state.style}
                          fontValue={value.fontFamily}
                          getFontStyleWeight={this._getFontStyleWeight}
                          currentFontWeight={this.state.fontWeight}
                          isParentActive={isActive}
                        />
                      ) : null}
                      <span className="font-title">{value.fontFamily}</span>
                      {optionsAvailable ? (
                        <i className="ic-dropdown">
                          <FontAwesomeIcon
                            icon={["far", "angle-right"]}
                            className="breadcrumb-bredcrumb-icon"
                          />
                        </i>
                      ) : null}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RevvToolBar/CustomFontStyle/CustomFontStyle.js